import Box from '@amzn/meridian/box';
import React from 'react';
import { useParams, useLocation } from 'react-router';
import CCXDetailsPage from './CCXDetailsPage';

const CCXDetailsHome: React.FC = (): React.ReactElement => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const rating = params.get('rating');
  const verticalValue = params.get('verticalValue');
  const skillValue = params.get('skillValue');
  const segmentValue = params.get('segmentValue');
  const channelValue = params.get('channelValue');
  const marketplaceValue = params.get('marketplaceValue');
  const weekValue = params.get('weekValue');

  const paramsProps = {
    rating,
    verticalValue,
    skillValue,
    segmentValue,
    channelValue,
    marketplaceValue,
    weekValue,
  };

  const { userId } = useParams() as {
    userId: string;
  };

  return (
    <Box>
      <CCXDetailsPage userId={userId} {...paramsProps} />
    </Box>
  );
};

export default CCXDetailsHome;
